
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.844 17.707a1.012 1.012 0 01-.717-.3l-3.828-3.833a1.024 1.024 0 010-1.436 1.019 1.019 0 011.434 0l3.111 3.116 6.951-6.964a1.015 1.015 0 111.434 1.436l-7.669 7.683a1.012 1.012 0 01-.716.298z","fill":"#fff"}})])
          )
        }
      }
    